import React from 'react';
import EnvContext from 'src/contexts/EnvContext';

const useEnv = () => React.useContext(EnvContext);

export default useEnv;
